/**
 * Sovyer: shimmer placeholder for product images while they load.
 * Watches every `.card-gallery` (product cards, collection grids, featured-product,
 * product page gallery) and shows a soft moving shimmer + fades the image in on load,
 * instead of a blank/empty box. Re-scans on DOM changes (quick-add, section re-renders,
 * infinite scroll) via MutationObserver.
 */
(function () {
  function isLoaded(img) {
    return img.complete && img.naturalWidth > 0;
  }

  function watch(gallery) {
    if (gallery.dataset.sovyerShimmerWatched) return;
    gallery.dataset.sovyerShimmerWatched = 'true';

    var img = gallery.querySelector('img.product-media__image');
    if (!img) return;
    if (isLoaded(img)) return;

    gallery.classList.add('sovyer-img-loading');

    var poll = null;

    function done() {
      gallery.classList.remove('sovyer-img-loading');
      img.removeEventListener('load', done);
      img.removeEventListener('error', done);
      if (poll) clearInterval(poll);
    }

    img.addEventListener('load', done);
    img.addEventListener('error', done);

    // Safety net: some browsers report `complete: true` with naturalWidth 0
    // for an instant right as a cached image starts resolving, and in that
    // case `load` never fires again. Poll briefly (max ~2s) as a fallback so
    // the shimmer can never get stuck.
    var attempts = 0;
    poll = setInterval(function () {
      attempts += 1;
      if (isLoaded(img) || attempts > 20) done();
    }, 100);
  }

  function scan(root) {
    (root || document).querySelectorAll('.card-gallery').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('card-gallery')) watch(node);
        if (node.querySelectorAll) scan(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
